import type { ApiModuleEndpoints } from '../types'

export const branchApiEndpoints = {
  list: {
    method: 'GET',
    path: '/branches',
    requiresAuth: true,
  },
  options: {
    method: 'GET',
    path: '/branches/options',
    requiresAuth: true,
  },
  detail: {
    method: 'GET',
    path: '/branches/:id',
    requiresAuth: true,
  },
  create: {
    method: 'POST',
    path: '/branches',
    requiresAuth: true,
  },
  update: {
    method: 'PUT',
    path: '/branches/:id',
    requiresAuth: true,
  },
  delete: {
    method: 'DELETE',
    path: '/branches/:id',
    requiresAuth: true,
  },
  restore: {
    method: 'POST',
    path: '/branches/:id/restore',
    requiresAuth: true,
  },
  current: {
    method: 'POST',
    path: '/branches/current',
    requiresAuth: true,
  },
} as const satisfies ApiModuleEndpoints
